import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { UserProvider } from './contexts/UserContext';
render(<UserProvider data-id="element-7041" data-mp="1wbcynwfxzjge">
    <App data-id="element-7042" data-mp="1wcxt7m29b2e9" />
  </UserProvider>, document.getElementById('root'));